import Paragraph from 'antd/lib/typography/Paragraph'
import { VideoPlayer } from 'shared/components/VideoPlayer/VideoPlayer'
import { MediaTypeDefinitions } from 'Types/Tasks.types'
import 'video.js/dist/video-js.css'
import styles from '../Prompt.module.less'

export type PromptVideoContentPropsType = {
    content: MediaTypeDefinitions
    id: string
}

export const PromptVideoContent = (props: PromptVideoContentPropsType) => {
    return (
        <div className={styles['video-content']} id={props.id}>
            <Paragraph>{props.content.label}</Paragraph>
            <div className={styles['video-content-container']}>
                <VideoPlayer url={props.content.url} id={props.id} />̦
            </div>
        </div>
    )
}
